import { Controller } from '@hotwired/stimulus'

export default class KycFileBackSelectionMenuController extends Controller {
  static targets = [
    'choseSeparateFiles',
    'choseSingleFile',
    'fileBackInputBlock',
    'fileFrontAndBackInputBlock',
    'selectedKycType',
    'singleOrSeparateFileChoiceButtons',
    'navChoseSeparateFiles',
    'navChoseSingleFile',
  ];

  connect() {
    this.toggleSingleFileOrMultipleFilesMenu();
  }

  toggleSingleFileOrMultipleFilesMenu() {
    this.#showInputsIfATypeIsSelected();
    this.#toggleSingleOrSeparateFileChoiceButtons();
    this.toggleFileBackInput();
  }

  toggleFileBackInput() {
    if (this.choseSeparateFilesTarget.checked && this.#canSelectedDocumentTypeHaveABack()) {
      this.fileBackInputBlockTarget.classList.remove('d-none');
      this.fileBackInputBlockTarget.querySelectorAll('[name*="[file_back]"]').forEach((el) => (el.disabled = false));
      this.navChoseSingleFileTarget.classList.remove('bg-white', 'text-dark');
      this.navChoseSeparateFilesTarget.classList.add('bg-white', 'text-dark');
    } else {
      this.fileBackInputBlockTarget.classList.add('d-none');
      this.fileBackInputBlockTarget.querySelectorAll('[name*="[file_back]"]').forEach((el) => (el.disabled = true));
      this.navChoseSingleFileTarget.classList.add('bg-white', 'text-dark');
      this.navChoseSeparateFilesTarget.classList.remove('bg-white', 'text-dark');
    }
  }

  // private

  #toggleSingleOrSeparateFileChoiceButtons() {
    this.singleOrSeparateFileChoiceButtonsTarget.classList.toggle('d-none', !this.#canSelectedDocumentTypeHaveABack());
    if (this.#canSelectedDocumentTypeHaveABack()) {
      this.choseSingleFileTarget.checked = true;
      this.choseSeparateFilesTarget.checked = false;
    }
  }

  #canSelectedDocumentTypeHaveABack() {
    return this.selectedKycTypeTarget.options[this.selectedKycTypeTarget.selectedIndex].dataset.mayHaveBack === 'true';
  }

  #showInputsIfATypeIsSelected() {
    if (this.selectedKycTypeTarget.selectedIndex == 0) {
      this.fileFrontAndBackInputBlockTarget.classList.add('d-none');
    } else {
      this.fileFrontAndBackInputBlockTarget.classList.remove('d-none');
    }
  }
}
